module.exports = __webpack_public_path__ + "img/portrait.3ea3b339.svg";